export const FixedColorsRGB = {
    light: {
        on_background: "255, 255, 255",
    },
};
export const FixedColors = {
    primary: "#00AB80",
    dark: {
        600: "#0F0F0F",
        500: "#DFE1E5",
        400: "#BDC2C9",
        300: "#83888F",
        200: "#787C82",
        100: "#676A6E",
    },
    light: {
        50: "#4F5154",
        40: "#36373B",
        30: "#232426",
        20: "#1F1F21",
        10: "#1A1B1C",
        background: "#151617",
        surface: "#1A1B1C",
        on_background: "#FFFFFF",
    },
    state: {
        error: "#FF5858",
        success: "#04CC83",
        link: "#71B6FF",
        alert: "#F2682C",
    },
    mask: "0, 0, 0",
};
export const MAVIZ_THEME = {
    colors: {
        primary: {
            40: "#00D1A8",
            50: "#00B894",
            60: "#109E82",
        },
        error: "#E82A3C",
        success: "#24863D",
        link: "#1677FF",
        alert: "#E55A2E",
        dark: {
            100: "#B3BAC5",
            ["const_100"]: "#B3BAC5",
            200: "#7A869A",
            ["const_200"]: "#7A869A",
            300: "#5E6C84",
            ["const_300"]: "#5E6C84",
            400: "#42526E",
            ["const_400"]: "#42526E",
            500: "#091E42",
            ["const_500"]: "#091E42",
            600: "#0f0f0f",
            ["const_600"]: "#0F0F0F",
        },
        light: {
            on_primary: "#FFFFFF",
            surface: "#FCFDFD",
            on_app_bar: "#091E42",
            gold_bg: "#FFF3AE",
            0: "#FCFDFD",
            ["const_0"]: "#FCFDFD",
            10: "#FAFBFC",
            ["const_10"]: "#FAFBFC",
            20: "#F4F5F7",
            ["const_20"]: "#F4F5F7",
            30: "#EBECF0",
            ["const_30"]: "#EBECF0",
            40: "#DFE1E6",
            ["const_40"]: "#DFE1E6",
            50: "#C1C7D0",
            ["const_50"]: "#C1C7D0",
        },
        alternative: {
            1: "#F2AA00",
            2: "#F28816",
            3: "#FF6B6A",
            4: "#F257A8",
            5: "#B37FEB",
            6: "#9BD900",
            7: "#52C41A",
            8: "#9E52FF",
            9: "#29B6F6",
            10: "#597EF7",
        },
        bubble: {
            out_primary: "#DCFAF5",
            in_primary: "#FCFDFD",
            out_secondary: "#13C2C2",
            in_secondary: "#4FC3F7",
            low_text: "#6A7485",
            receipt: "#FFF1B8",
            seen_in_dark_bg: "#04CC83",
        },
        background: {
            chat: "#FFFFFF",
        },
        complementary: {
            1: "#238FF3",
            2: "#091E42",
            3: "#FFFFFF",
            4: "#DFE1E6",
        },
        call: {
            background: "#151617",
            chips_background: "#1A1B1C",
            grid_background: "#232426",
            default_button: "#36373B",
            end_button: "#E14D4D",
            call_button: "#00AB80",
            toast: "#EBECF0",
            share_screen: "#4A98E9",
            on_background: "#FFFFFF",
        },
        magazine: {
            gradient_start: "#F860DB",
            gradient_end: "#4684FC",
        },
        mask: "9, 30, 66",
        snack: "9, 30, 66",
        skeleton: "linear-gradient(90deg,#091d421a 0%,#091e420a 45%,#091e420a 55%,#091e421a 100%);",
        gradient: {
            magzine: "linear-gradient(129deg, #4684FC 13.9%, #F860DB 84.3%)",
            skeleton: "linear-gradient(90deg,#091d421a 0%,#091e420a 45%,#091e420a 55%,#091e421a 100%)",
            story_arbaein: "linear-gradient(332deg, #FF8311 -29.89%, #FA9817 0.84%, #FCAF2E 37.21%, #FEC03F 64.8%, #FFCE4D 86.75%)",
            story_world: "linear-gradient(134deg, #B73ABD -21.62%, #BA8BF4 32.79%, #32CBF4 58.01%, #5BF59F 91.85%)",
            story_yalda: "linear-gradient(147deg, #F9607C 5.84%, #FFCFCF 92.01%)",
            story: "linear-gradient(148deg, #09B188 23.71%, #2DC297 40.36%, #60DAAC 64.07%, #7BE6B7 76.3%, #72E3A6 91.47%)",
        },
        ripple: "#00B894",
        primary_ripple: "#000000",
        fixed: FixedColors,
    },
};
export const MAVIZ_THEME_RGB = {
    primary: {
        40: "0, 209, 168",
        50: "0, 184, 148",
        60: "16, 158, 130",
    },
    dark: {
        100: "179, 186, 197",
        200: "122, 134, 154",
        300: "94, 108, 132",
        400: "66, 82, 110",
        500: "9, 30, 66",
        600: "15, 15, 15",
    },
    light: {
        surface: "252, 253, 253",
        on_primary: "255, 255, 255",
        gold_bg: "255, 243, 174",
        0: "252, 253, 253",
        10: "250, 251, 252",
        20: "244, 245, 247",
        30: "235, 236, 240",
        40: "223, 225, 230",
        50: "193, 199, 208",
    },
    alternative: {
        a01: "242, 170, 0",
        a02: "242, 136, 22",
        a03: "255, 107, 106",
        a04: "242, 87, 168",
        a05: "179, 127, 235",
        a06: "155, 217, 0",
        a07: "82, 196, 26",
        a08: "158, 82, 255",
        a09: "41, 182, 246",
        a10: "89, 126, 247",
        opacity: "0.2",
    },
    bubble: {
        out_primary: "220, 250, 245",
        in_primary: "252, 253, 253",
        out_secondary: "19, 194, 194",
        out_third: "19, 194, 194",
        in_third: "179, 186, 197",
        in_secondary: "79, 195, 247",
        low_text: "106, 116, 133",
        receipt: "255, 241, 184",
        service_message: "0, 0, 0",
    },
    mask: "9, 30, 66",
    snack: "9, 30, 66",
    ripple: "0, 184, 148",
    primary_ripple: "0, 0, 0",
    fixed: FixedColorsRGB,
};
export const DARK_THEME_RGB = {
    primary: {
        40: "0, 196, 147",
        50: "0, 171, 128",
        60: "0, 145, 109",
    },
    dark: {
        100: "103, 106, 110",
        200: "120, 124, 130",
        300: "131, 136, 143",
        400: "189, 194, 201",
        500: "223, 225, 229",
        600: "11, 14, 20",
    },
    light: {
        surface: "37, 38, 38",
        on_primary: "255, 255, 255",
        gold_bg: "56, 46, 20",
        0: "21, 22, 23",
        10: "26, 27, 28",
        20: "31, 31, 33",
        30: "35, 36, 38",
        40: "54, 55, 59",
        50: "79, 81, 84",
    },
    alternative: {
        a01: "254, 178, 0",
        a02: "255, 143, 23",
        a03: "255, 107, 106",
        a04: "255, 92, 177",
        a05: "188, 134, 247",
        a06: "164, 229, 0",
        a07: "87, 209, 28",
        a08: "169, 102, 255",
        a09: "43, 189, 255",
        a10: "92, 130, 255",
        opacity: "0.1",
    },
    bubble: {
        out_primary: "0, 92, 86",
        in_primary: "48, 50, 51",
        out_secondary: "34, 168, 160",
        in_secondary: "96, 171, 204",
        in_third: "98, 100, 102",
        out_third: "130, 222, 216",
        low_text: "192, 201, 209",
        receipt: "84, 78, 59",
        service_message: "256, 256, 256",
    },
    mask: "0, 0, 0",
    snack: "223, 225, 229",
    ripple: "0, 171, 128",
    primary_ripple: "0, 171, 128",
    fixed: FixedColorsRGB,
};
export const DARK_THEME = {
    colors: {
        primary: {
            40: "#00C493",
            50: "#00AB80",
            60: "#00916D",
        },
        error: "#FF5858",
        success: "#04CC83",
        link: "#71B6FF",
        alert: "#F2682C",
        dark: {
            100: "#676A6E",
            ["const_100"]: "#B3BAC5",
            200: "#787C82",
            ["const_200"]: "#7A869A",
            300: "#83888F",
            ["const_300"]: "#5E6C84",
            400: "#BDC2C9",
            ["const_400"]: "#42526E",
            500: "#DFE1E5",
            ["const_500"]: "#091E42",
            600: "#0B0E14",
            ["const_600"]: "#0F0F0F",
        },
        light: {
            on_primary: "#FFFFFF",
            surface: "#252626",
            on_app_bar: "#DFE1E5",
            gold_bg: "#382E14",
            0: "#151617",
            ["const_0"]: "#FCFDFD",
            10: "#1A1B1C",
            ["const_10"]: "#FAFBFC",
            20: "#1F1F21",
            ["const_20"]: "#F4F5F7",
            30: "#232426",
            ["const_30"]: "#EBECF0",
            40: "#36373B",
            ["const_40"]: "#DFE1E6",
            50: "#4F5154",
            ["const_50"]: "#C1C7D0",
        },
        alternative: {
            1: "#FEB200",
            2: "#FF8F17",
            3: "#FF6B6A",
            4: "#FF5CB1",
            5: "#BC86F7",
            6: "#A4E500",
            7: "#57D11C",
            8: "#A966FF",
            9: "#2BBDFF",
            10: "#5C82FF",
        },
        bubble: {
            out_primary: "#005C56",
            in_primary: "#303233",
            out_secondary: "#22A8A0",
            in_secondary: "#60ABCC",
            low_text: "#C0C9D1",
            receipt: "#544E3B",
            seen_in_dark_bg: "#04CC83",
        },
        background: {
            chat: "#1A1B1C",
        },
        complementary: {
            1: "#238FF3",
            2: "#091E42",
            3: "#FFFFFF",
            4: "#DFE1E6",
        },
        call: {
            background: "#151617",
            chips_background: "#1A1B1C",
            grid_background: "#232426",
            default_button: "#36373B",
            end_button: "#E14D4D",
            call_button: "#00AB80",
            toast: "#EBECF0",
            share_screen: "#4A98E9",
            on_background: "#FFFFFF",
        },
        magazine: {
            gradient_start: "#F860DB",
            gradient_end: "#4684FC",
        },
        mask: "0, 0, 0",
        snack: "223, 225, 229",
        skeleton: "linear-gradient(90deg,#36373b4d 0%,#36373b99 50%,#36373b4d 100%);",
        gradient: {
            magzine: "linear-gradient(129deg, #4684FC 13.9%, #F860DB 84.3%)",
            skeleton: "linear-gradient(90deg,#36373b4d 0%,#36373b99 50%,#36373b4d 100%)",
            story_arbaein: "linear-gradient(332deg, #FF8311 -29.89%, #FA9817 0.84%, #FCAF2E 37.21%, #FEC03F 64.8%, #FFCE4D 86.75%)",
            story_world: "linear-gradient(134deg, #B73ABD -21.62%, #BA8BF4 32.79%, #32CBF4 58.01%, #5BF59F 91.85%)",
            story_yalda: "linear-gradient(147deg, #F9607C 5.84%, #FFCFCF 92.01%)",
            story: "linear-gradient(148deg, #09B188 23.71%, #2DC297 40.36%, #60DAAC 64.07%, #7BE6B7 76.3%, #72E3A6 91.47%)",
        },
        ripple: "#00AB80",
        primary_ripple: "#000000",
        fixed: FixedColors,
    },
};
//# sourceMappingURL=themes.js.map